import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Star, Upload, X } from "lucide-react";
import { useApi } from "@/lib/useApi";
import { errMsg, imgUrl } from "@/lib/api";
import { Label } from "@/components/ui/label";

const MAX = 8;

export const ImagesField = ({ images, onChange }) => {
  const call = useApi();
  const [busy, setBusy] = useState(false);
  const [over, setOver] = useState(false);

  const upload = async (fileList) => {
    const files = Array.from(fileList || []).filter((f) => f.type.startsWith("image/"));
    const room = MAX - images.length;
    if (files.length > room) toast.error(`Maksimal ${MAX} foto per produk`);
    if (!files.length || room <= 0) return;
    setBusy(true);
    try {
      const urls = [];
      for (const f of files.slice(0, room)) {
        const fd = new FormData(); fd.append("file", f);
        urls.push((await call("post", "/admin/upload", fd)).url);
      }
      onChange([...images, ...urls]);
    } catch (err) { toast.error(errMsg(err, "Upload gagal")); } finally { setBusy(false); }
  };

  const makePrimary = (i) => onChange([images[i], ...images.filter((_, j) => j !== i)]);

  return (
    <div className="space-y-2">
      <Label>Foto produk ({images.length}/{MAX}) — minimal 1, foto pertama jadi foto utama</Label>
      <div className="flex flex-wrap gap-2">
        {images.map((src, i) => (
          <div key={src + i} className={`relative h-24 w-24 overflow-hidden rounded-md border-2 ${i === 0 ? "border-amber-600" : "border-stone-200"}`} data-testid={`product-image-${i}`}>
            <img src={imgUrl(src)} alt="" className="h-full w-full object-cover" />
            <button type="button" onClick={() => onChange(images.filter((_, j) => j !== i))} className="absolute right-1 top-1 rounded-full bg-white/90 p-0.5" data-testid={`product-form-remove-image-${i}`}><X className="h-3 w-3" /></button>
            {i > 0 && <button type="button" title="Jadikan foto utama" onClick={() => makePrimary(i)} className="absolute bottom-1 left-1 rounded-full bg-white/90 p-0.5" data-testid={`product-image-primary-${i}`}><Star className="h-3 w-3" /></button>}
          </div>
        ))}
      </div>
      {images.length < MAX && (
        <label data-testid="product-image-dropzone"
          onDragOver={(e) => { e.preventDefault(); setOver(true); }} onDragLeave={() => setOver(false)}
          onDrop={(e) => { e.preventDefault(); setOver(false); upload(e.dataTransfer.files); }}
          className={`flex cursor-pointer flex-col items-center justify-center gap-1 rounded-md border-2 border-dashed p-5 text-sm ${over ? "border-amber-600 bg-amber-50" : "border-stone-300 text-stone-500 hover:bg-stone-50"}`}>
          {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : <Upload className="h-5 w-5" />}
          <span>Tarik & lepas foto ke sini, atau klik untuk memilih</span>
          <input type="file" accept="image/*" multiple className="hidden" onChange={(e) => { upload(e.target.files); e.target.value = ""; }} data-testid="product-form-image-upload" />
        </label>
      )}
    </div>
  );
};
